<template>
  <div class="ui-card__body">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CardBody',
})
</script>

<style lang="stylus">
.ui-card__body
  padding .75rem 1.25rem
</style>
